import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar/Sidebar";
import Head from "./head/Head";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import AppRoot from "./global/AppRoot";
import AppMain from "./global/AppMain";
import AppWrap from "./global/AppWrap";
import { ToastContainer, toast } from "react-toastify";

import FileManagerProvider from "../pages/app/file-manager/components/Context";

import "react-toastify/dist/ReactToastify.css";

const Layout = ({ title, ...props }) => {
  return (
    <FileManagerProvider>
      <Head title={!title && "Loading"} />
      <AppRoot>
        <AppMain>
          <Sidebar fixed />
          <AppWrap>
            <Header fixed />
            <Outlet />
            <Footer />
          </AppWrap>
        </AppMain>
      </AppRoot>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* Había un segundo <ToastContainer /> aquí: cada aviso del panel se
          mostraba dos veces, uno encima del otro. */}
    </FileManagerProvider>
  );
};
export default Layout;
